import { useCms } from "./useCms";

/**
 * usePageContent
 * -----------------
 * Reads one PageContent row (Admin > Homepage > "Why Us Page" / "Packages
 * Page" tabs) by its pageKey - heading/intro/seoTitle/seoDescription/
 * ctaLabel/ctaUrl plus a flexible `body` JSON blob for anything page-
 * specific (e.g. the homepage preview's 3 selling points). Mirrors
 * useHomepageSection.js's shape/fallback conventions exactly, just against
 * /api/homepage/pages/:pageKey instead of /sections.
 *
 * Returns null while loading or if no admin row exists yet for this page -
 * callers should fall back to their own static defaults in that case,
 * same as every other CMS-backed section on this site.
 */
export function usePageContent(pageKey) {
  const { data } = useCms(`/api/homepage/pages/${pageKey}`, null);
  return data;
}
